import { render, staticRenderFns } from "./SkuMappings.vue?vue&type=template&id=bc0bf76a&scoped=true"
import script from "./SkuMappings.vue?vue&type=script&lang=js"
export * from "./SkuMappings.vue?vue&type=script&lang=js"
import style0 from "./SkuMappings.vue?vue&type=style&index=0&id=bc0bf76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0bf76a",
  null
  
)

export default component.exports